// keys and student routes of menu items
export const studentUIPaths = {
  "my-scores": ["my-scores"],
  "contact-us": ["contact-us"],
  "feedback": ["feedback"],
  "my-profile": ["my-profile"],
  "logout": ["logout"],
  "student-dashboard": [
    "student-dashboard",
    "image-listing",
    "video-listing",
    "video-preview",
    "flashcard-listing",
    "flashcard-view",
    "image-quiz-listing",
    "image-quiz-results",
    "image-quiz-instructions",
    "image-quiz",
    "image-quiz-review-incorrect",
    "test-results",
    "test-listing",
    "instructions",
    "retake-test",
    "resume-test",
  ],
  "home": ["home"],
  "help": ["help",
    "how-do-i-access-the-online-resources",
    "how-do-i-find-the-access-code-to-register-for-the-practice-exams",
    "can-someone-else-use-my-subscription",
    "why-is-my-book-code-invalid",
    "i-did-not-receive-an-email-after-registration-what-do-i-do",
    "i-am-not-receiving-mails-from-this-site",
    "what-should-i-do-if-i-have-forgotten-my-username-or-password",
    "how-long-will-i-be-able-to-access-my-account",
    "what-should-i-do-if-i-cannot-access-the-online-resources",
    "why-can-t-i-login-my-account",
  ],
  "acknowledgements": ["acknowledgements"],
};

// keys and admin routes of menu items
export const adminUIPaths = {
  "admin-dashboard": ["admin-dashboard"],
  "admin-users": ["admin-users"],
  "student-users": ["student-users"],
  "test-score": ["test-score", "review-incorrect", "review-all"],
  "generate-codes": ["generate-codes"],
  "book-code-list": ["book-code-list"],
  "tests": ["test-listing", "question-listing", "question-update", "question-add"],
  "images": ["image-listing"],
  "image-quizzes": [
    "image-quiz-listing",
    "image-quiz",
    "image-quiz-update",
    "image-quiz-add",
  ],
  "image-quiz-scores" : [ "image-quiz-scores", "image-quiz-results", "image-quiz-review-incorrect"],
  "videos": ["video-listing"],
  "flashcards": ["flashcard-listing", "flashcard-questions", "flashcard-add"],
  "my-profile": ["my-profile"],
  "logout": ["logout"],
  "universities": ["university-master", "add-university"],
  "documents": ["document-listing"],
  "settings": ["settings"],
  "crons" : ["cron-activity", "response-data"],
  "flashcard-analysis": ["flashcard-analysis"]
};